export const rotateForce = (planar, ...args) => {
};

export const forceStart = (planar, ...args) => {
    let [forceNumber, x, y] = args;
    let keys = Object.keys(planar.groups[0].forces);
    let key = keys[forceNumber];
    let force = planar.groups[0].forces[key];

    force[0].set(x);
    force[1].set(y);
};


export const forceDirection= (planar, ...args) => {
    let [forceNumber, x, y] = args;
    let keys = Object.keys(planar.groups[0].forces);
    let key = keys[forceNumber];
    let force = planar.groups[0].forces[key];

    force[2].set(x);
    force[3].set(y);
};

